
import Checkbox from "primevue/checkbox";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  isOpen = prop<boolean>({
    default: false,
    required: true,
    type: Boolean
  });
}

@Options({
  emits: ["update:isOpen", "confirm"],
  components: {
    Checkbox
  }
})
class ModalTermsCondition extends Vue.with(Props) {
  agreements = [false, false, false];
  isAgree = false;

  get isNotValid() {
    if (this.agreements.includes(false)) {
      this.isAgree = false;
    }
    return this.agreements.includes(false);
  }

  onCloseModal() {
    this.$emit("update:isOpen", false);
  }

  onConfirm() {
    this.$emit("confirm");
    this.agreements = [false, false, false];
  }
}
export default ModalTermsCondition;
